module.exports.launchMap = function (location, error_message) {
    console.log("inside Launch Map")
    const regexExp = /^((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/gi;
    if(regexExp.test(location)){
      window.open('https://www.google.com/maps/search/?api=1&query='+location.replace(',',"%2C"));
    } else {
      if(error_message){
        alert(error_message);
      } else {
        alert("Invalid map coordinates");
      }

    }
}